import React from 'react'
const LotteryContext = React.createContext()
export default LotteryContext
